import styled from "styled-components";

export const ThumbnailLightboxStyle = styled.div`
    display: flex;
    flex-wrap: wrap;

    .media {
        position: relative;
        padding: 0px 5px 10px 5px;
        cursor: pointer;
        transition: transform 0.2s;
        width: 33%;

        img {
            border-radius: 8px;
            overflow: hidden;
            width: 100%;
            display: block;
        }

        .google-lens-link {
            position: absolute;
            right: 5px;
            bottom: 10px;
            width: 40px;
            z-index: 2;
            filter: brightness(0) saturate(100%) invert(80%) sepia(9%) saturate(2083%) hue-rotate(151deg) brightness(96%) contrast(85%);
        }

        &:hover {
            transform: scale(1.01);
        }
    }
`;
